import { slugs } from '@/constants/slugs'
import { TranslateFunction } from '@/utils/translate/translate-client'
import { GiveawayConfig } from '../../types'
import {
  createBaseConfig,
  createStandardTabs,
  createStandardTicketFlow,
  angelImagesUrl,
  staticAssetUrl,
} from '../shared'

export const getSoloMioConfig = (t: TranslateFunction): GiveawayConfig => {
  return createBaseConfig({
    theatricalSlug: slugs.soloMio,
    heroTitle: t('win7DayItalianGetaway', 'Win a 7-Day Italian Getaway for 2'),
    logoUrl: angelImagesUrl('v1768499043/solo%20mio/solo-mio-logo'),
    footerLogoUrl: angelImagesUrl('v1768499043/solo%20mio/solo-mio-logo'),
    inTheatersText: t('inTheatersSoloMio', 'In theaters February 6, 2026'),
    videoImage: angelImagesUrl('v1768499043/solo%20mio/details-video-thumbnail-no-play-button'),
    releaseDate: 'February 6, 2026',
    backgroundVideoUrl: 'https://images.angelstudios.com/video/upload/v1765324869/solo-mio-looping-video-v2_pye9k3.mp4',
    share: {
      shareText:
        'You’re entering the Solo Mio Getaway for your chance to win a trip for two to Rome and Florence Italy, plus $10,000 cash. Get your tickets at angel.com/solomiogiveaway',
      hashtag: '#SoloMioGiveaway',
      shareImage: staticAssetUrl('v1763825328/solo%20mio/social-modal-desktop'),
      shareImageMobile: staticAssetUrl('v1763825333/solo%20mio/social-modal-mobile'),
    },

    ticketFlow: createStandardTicketFlow({
      t,
      projectSlug: slugs.soloMio,
      congratsKey: 'soloMioCongratsModalText',
      congratsText:
        "You've earned entries for your chance to win the Solo Mio Lovers Getaway! Complete your checkout to secure your entries.",
      // TODO: Add portrait image
      portraitImage: staticAssetUrl('v1763825328/solo%20mio/social-modal-desktop'),
      reservationKey: 'soloMioReservationCompleteText',
      reservationText: "You've earned entries for your chance to win the Solo Mio Lovers Getaway!",
      noShowtimesKey: 'soloMioNoShowtimes',
      noShowtimesText:
        "We're adding new theaters every week. While you wait, preorder tickets today for your chance to win the Solo Mio Lovers Getaway!",
      // TODO: Add landscape image
      landscapeImage: staticAssetUrl('v1763825333/solo%20mio/social-modal-mobile'),
    }),

    steps: [
      {
        title: t('preOrderTicketsV2', 'Preorder Tickets'),
        description: t('soloMioChooseYourTickets', 'Choose your tickets to Solo Mio below.'),
      },
      {
        title: t('receiveYourPromoCodes', 'Receive Your Promo Codes'),
        description: t(
          'eachTicketEarnsAPromoCode',
          'Each ticket earns you a unique promo code (redeemable when showtimes are available).',
        ),
      },
      {
        title: t('multiplyYourChances', 'Multiply Your Chances'),
        description: t(
          'theMoreTicketsYouBuy',
          'The more tickets you buy, and the earlier you buy them, the greater your entry multiplier, boosting your odds of winning!',
        ),
      },
    ],

    tabs: createStandardTabs(t),

    galleryImages: [],
    partnerLogos: [],
  })
}
